import { AwardConfigurationRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateAwardConfiguration: (
  fetchContext: FetchContext,
  awardId: number,
  awardConfiguration: AwardConfigurationRequest,
  accessToken?: string,
) => Promise<void> = async (fetchContext, awardId, awardConfiguration, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/awards/${awardId}/config`,
  {
    method: 'PUT',
    body: JSON.stringify(awardConfiguration),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update award configuration'));
